import { notification } from 'antd';
import { IconType } from 'antd/lib/notification';

export const handleNotification = (message: string, type: IconType, t: any) => {
    switch (type) {
        case 'error':
            return notification[type]({
                message: t('ERROR'),
                description: message,
            });

        case 'success':
            return notification[type]({
                message: t('SUCCESS'),
                description: message,
            });

        default:
            return;
    }
};
